// @ts-nocheck
import React from 'react';

const SalesOrderDeleteAlert = React.lazy(
  () => import('@/containers/Alerts/SalesOrder/SalesOrderDeleteAlert'),
);
const SalesOrderDeliverAlert = React.lazy(
  () => import('@/containers/Alerts/SalesOrder/SalesOrderDeliverAlert'),
);
const CancelBadDebtAlert = React.lazy(
  () => import('@/containers/Alerts/SalesOrder/CancelBadDebtAlert'),
);

/**
 * Sales orders alert.
 */
export default [
  { name: 'sales-order-delete', component: SalesOrderDeleteAlert },
  { name: 'sales-order-deliver', component: SalesOrderDeliverAlert },
  { name: 'cancel-bad-debt', component: CancelBadDebtAlert },
];
